import React from 'react'

interface SettingsSectionProps {
  theme: string
  onThemeChange: (theme: string) => void
  onSignOut: () => void
}

const SettingsSection: React.FC<SettingsSectionProps> = ({ theme, onThemeChange, onSignOut }) => {
  const isDark = theme === 'sunrise-dark'

  return (
    <div className="card bg-base-200 shadow-xl mb-8">
      <div className="card-body">
        <h2 className="card-title mb-4">Settings</h2>
        <div className="space-y-4">
          <div className="form-control">
            <label className="label">
              <span className="label-text">Appearance</span>
            </label>
            <div className="flex items-center gap-3">
              <span className="text-sm" style={{ opacity: isDark ? 0.5 : 1 }}>Light</span>
              <input
                type="checkbox"
                className="toggle toggle-primary"
                checked={isDark}
                onChange={(e) => onThemeChange(e.target.checked ? 'sunrise-dark' : 'sunrise')}
              />
              <span className="text-sm" style={{ opacity: isDark ? 1 : 0.5 }}>Dark</span>
            </div>
          </div>

          <div className="divider"></div>

          <button className="btn btn-error" onClick={onSignOut}>
            Sign Out
          </button>
        </div>
      </div>
    </div>
  )
}

export default SettingsSection
